import { ItemRateBase } from './base/item-rate-base';

export class ItemRate extends ItemRateBase { }